import { Global, Module } from '@nestjs/common';
import { APP_INTERCEPTOR } from '@nestjs/core';
import { PrismaService } from '@cart/api-data-access';
import { ActivityController } from './activity.controller';
import { AuditAdminController } from './audit-admin.controller';
import { MerchantAuditController } from './merchant-audit.controller';
import { ActivityService } from './activity.service';
import { AuditBatchService } from './audit-batch.service';
import { AuditContextService } from './audit-context.service';
import { AuditInterceptor } from './audit.interceptor';
import { AuditTransactionInterceptor } from './audit-transaction.interceptor';
import { AuditRetentionService } from './audit-retention.service';
import { AuditQueryService } from './audit-query.service';
import { MerchantAuditService } from './merchant-audit.service';
import { AuditService } from './audit.service';
import { AuditTransactionService } from './audit-transaction.service';
import { AuditTriggerRegistry } from './audit-trigger-registry.service';
import { AuditWriterService } from './audit-writer.service';
import { OutboundLogService } from './outbound-log.service';

@Global()
@Module({
  controllers: [ActivityController, AuditAdminController, MerchantAuditController],
  providers: [
    PrismaService,
    AuditContextService,
    AuditWriterService,
    AuditTriggerRegistry,
    AuditBatchService,
    AuditTransactionService,
    AuditService,
    AuditQueryService,
    MerchantAuditService,
    OutboundLogService,
    ActivityService,
    AuditRetentionService,
    // Order matters: AuditInterceptor is registered first, so it is the OUTER
    // interceptor and has already established the request's audit context by
    // the time AuditTransactionInterceptor needs an actor to publish.
    {
      provide: APP_INTERCEPTOR,
      useClass: AuditInterceptor,
    },
    {
      provide: APP_INTERCEPTOR,
      useClass: AuditTransactionInterceptor,
    },
  ],
  exports: [
    AuditService,
    AuditQueryService,
    MerchantAuditService,
    AuditContextService,
    AuditTransactionService,
    AuditWriterService,
    AuditTriggerRegistry,
    AuditBatchService,
    AuditRetentionService,
    OutboundLogService,
    ActivityService,
  ],
})
export class AuditModule {}
